/* eslint-disable max-len */
import React from 'react'
import { useQuerySelector } from '~/utils'

export const ProductExtra: React.FC = () => {
	const extra = useQuerySelector('.product__extra')

	return extra && extra.innerHTML.length > 10 ? (
		<div
			className="rounded-xl bg-gray-100 px-4 py-6 text-xl"
			dangerouslySetInnerHTML={{ __html: extra.innerHTML }}
		/>
	) : null
}
